// Google AdMob 배너 광고 컴포넌트 (모바일 앱 전용)
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Capacitor } from '@capacitor/core';
import { AdMob, BannerAdSize, BannerAdPosition } from '@capacitor-community/admob';

/**
 * Google AdMob 배너 광고 컴포넌트
 * - 모바일 앱에서만 작동
 * - 웹에서는 아무것도 표시하지 않음 (AdSense 사용)
 */
const AdMobBanner = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const platform = Capacitor.getPlatform();

  useEffect(() => {
    // 웹 플랫폼에서는 아무것도 하지 않음
    if (platform === 'web') {
      return;
    }
    const initializeAdMob = async () => {
      try {
        // AdMob 초기화
        await AdMob.initialize({
          requestTrackingAuthorization: true,
          testingDevices: ['YOUR_TEST_DEVICE_ID'], // 테스트 기기 ID (선택사항)
        });

        setIsInitialized(true);
        console.log('AdMob 초기화 완료');
      } catch (error) {
        console.error('AdMob 초기화 실패:', error);
      }
    };

    initializeAdMob();
  }, [platform]);

  useEffect(() => {
    // 웹 플랫폼이거나 초기화되지 않았으면 아무것도 하지 않음
    if (platform === 'web' || !isInitialized) {
      return;
    }

    const showBanner = async () => {
      try {
        // 환경에 따라 자동 선택 (개발: 테스트 ID, 프로덕션: 실제 ID)
        const adId = process.env.NODE_ENV === 'production'
          ? process.env.REACT_APP_ADMOB_BANNER_ID || 'ca-app-pub-5603775291756158/4907881786'
          : process.env.REACT_APP_ADMOB_TEST_BANNER_ID || 'ca-app-pub-3940256099942544/6300978111';

        // 배너 광고 표시
        await AdMob.showBanner({
          adId,
          adSize: BannerAdSize.ADAPTIVE_BANNER, // 화면 너비에 맞게 자동 조정
          position: BannerAdPosition.BOTTOM_CENTER,
          margin: 0,
        });

        if (process.env.NODE_ENV === 'development') {
          console.log('AdMob 배너 광고 표시');
        }
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('AdMob 배너 광고 표시 실패:', error);
        }
      }
    };

    showBanner();

    // ⚠️ 광고는 앱 종료까지 계속 표시되어야 하므로 hideBanner() 제거
    // cleanup 함수 없음 (페이지 전환 시에도 광고 유지)
  }, [isInitialized, platform]);

  // 웹 플랫폼에서는 아무것도 렌더링하지 않음
  if (platform === 'web') {
    return null;
  }

  // 네이티브 광고이므로 UI 요소 반환하지 않음
  return <Box sx={{ height: 50 }} />; // 배너 높이만큼 공간 확보
};

export default AdMobBanner;
